import { useState } from 'react';
import experience from '../data/experience';
import ArtworkCredit from './ArtworkCredit';
import ArtworkSection from './ArtworkSection';
import ExperienceItem from './ExperienceItem';

const experienceImage = {
    jpg: '/art/western-luminism/looking-down-yosemite-valley-bierstadt-1920.jpg',
    srcSet: [
        '/art/western-luminism/looking-down-yosemite-valley-bierstadt-1280.jpg 1280w',
        '/art/western-luminism/looking-down-yosemite-valley-bierstadt-1920.jpg 1920w',
    ].join(', '),
};

function ExperienceSection() {
    const [openExperience, setOpenExperience] = useState(0);

    return (
        <ArtworkSection id="experience" className="content-slide" image={experienceImage}>
            <div className="slide-copy wide-copy">
                <p className="section-name">Experience</p>
                <div className="line-list">
                    {experience.map((item, index) => (
                        <ExperienceItem
                            item={item}
                            isOpen={openExperience === index}
                            key={`${item.company}-${item.date}`}
                            onToggle={() => setOpenExperience((current) => current === index ? null : index)}
                        />
                    ))}
                </div>
            </div>
            <ArtworkCredit>
                Albert Bierstadt · <cite>Looking Down Yosemite Valley</cite> · 1865
            </ArtworkCredit>
        </ArtworkSection>
    );
}

export default ExperienceSection;
